import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';


@Injectable()
export class CartService {

  private ngt18Url: string = environment.API_URL+'main/';
  
  constructor(private http: HttpClient) { }

  getBasketList(data) {
    return this.http.post(this.ngt18Url + 'module.p2p.listCart', data);
  }

}
